module.exports = __webpack_public_path__ + "static/homepage-hero-bg-m-2bf6bcf4f4b6dc6465bc19473d542126.jpg";